import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as Unicons from "@iconscout/react-unicons";
import Logo192 from "../assets/logo-full.png";
import { Icon } from "@iconify/react/dist/iconify.js";
import SearchJson from "../utils/title.json";

import useRole from "../utils/useRole";
import axios from "axios";
import { getAxiosConfig } from "../utils/helpers";
import { set } from "react-hook-form";
import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import ImgOptimized from "./ImgOptimized";
import PopupWrapper from "./PopupWrapper";
import SearchProjectWithDropDown from "./SearchProjectWithDropDown";

// Search categories from the theme-tagging sheet, mapped to their /showcase query param
const TAG_FILTER_PARAMS = {
  themes: "themes",
  price_ranges: "prices",
  project_categories: "categories",
};

function Header({
  position,
  bg,
  ProjectShowcase = false,
  OnChangeSearchInput = () => {},
  isShowProjectDropDown = false,
  allProjects = [],
  initialSearchValue = "",
}) {
  const nav = useNavigate();
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [exploreMenuOpen, setExploreMenuOpen] = useState(false);
  const [libraryMenuOpen, setLibraryMenuOpen] = useState(false);
  const { isSuperAdmin, role } = useRole();
  // console.log("ROLE IN HEADER", role, isSuperAdmin);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const history = useNavigate();

  const logoutuser = () => {
    localStorage.removeItem("usersdatatoken");
    history("/");
  };

  const [searchInput, setSearchInput] = useState(initialSearchValue);
  const [showSearchMenu, setShowSearchMenu] = useState(false);
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);
  const categories = Object.keys(SearchJson).filter((key) => {
    // if(key === "size" || key === "Size"){
    //   return
    // }
    return Array.isArray(SearchJson[key]);
  });

  const [searchResults, setSearchResults] = useState({});

  // const searchHandler = (e) => {
  //   e.preventDefault();
  //   history(`/project?mask=${searchInput}`);
  //   setSearchInput("");
  // };
  // Search handler for form submit
  const searchHandler = (e) => {
    e.preventDefault();
    setShowSearchMenu(false);
    // if (searchInput.trim()) {
    //   history(`/project?mask=${searchInput}`);
    //   setSearchInput("");
    // }
    const searchResultKeys = searchInput ? Object.keys(searchResults) : [];
    const firstKey = searchResultKeys.length > 0 ? searchResultKeys[0] : "";
    const searchBasedOnFirstKey = firstKey && searchResults[`${firstKey}`];
    const firstElem = searchBasedOnFirstKey && searchBasedOnFirstKey[0];
    const route = firstElem;

    if (route && firstKey && searchInput.trim()) {
      switch (firstKey) {
        case "sub_categories":
          nav(
            `/showcase?type=${
              SearchJson[firstKey]?.find((v) => v.label == firstElem.name)?.slug
            }`,
          );
          // console.log(
          //   "To ----> ",
          //   `/showcase?type=${SearchJson[firstKey]?.find((v) => v.label == firstElem.name)?.slug}`,
          // );
          setSearchInput("");
          setShowSearchMenu(false);
          break;
        case "color_themes":
          nav(
            `/showcase?colours=${
              SearchJson[firstKey]?.find((v) => v.label == firstElem.name)?.slug
            }`,
          );
          // console.log(
          //   "To ----> ",
          //   `/showcase?type=${SearchJson[firstKey]?.find((v) => v.label == firstElem.name)?.slug}`,
          // );
          setSearchInput("");
          setShowSearchMenu(false);
          break;
        case "zones":
          nav(
            `/showcase?tags=${
              SearchJson[firstKey]?.find((v) => v.label == firstElem.name)?.slug
            }`,
          );
          // console.log(
          //   "To ----> ",
          //   `/showcase?type=${SearchJson[firstKey]?.find((v) => v.label == firstElem.name)?.slug}`,
          // );
          setSearchInput("");
          setShowSearchMenu(false);
          break;
        case "themes":
        case "price_ranges":
        case "project_categories":
          nav(
            `/showcase?${TAG_FILTER_PARAMS[firstKey]}=${
              SearchJson[firstKey]?.find((v) => v.label == firstElem.name)?.slug
            }`,
          );
          setSearchInput("");
          setShowSearchMenu(false);
          break;
        case "years":
          // console.log("To ----> ", `/showcase?years=${firstElem.name}`);
          nav(`/showcase?years=${firstElem.name}`);
          setSearchInput("");
          setShowSearchMenu(false);
          break;
        case "countries":
          // console.log("To ----> ", `/showcase?countries=${firstElem.name}`);
          nav(`/showcase?countries=${firstElem.name}&type=country`);
          setSearchInput("");
          setShowSearchMenu(false);
          break;
        case "titles":
          nav(`/showcase?search=${firstElem.name}&type=title`);
          setSearchInput("");
          setShowSearchMenu(false);
          break;
        case "cities":
          nav(`/showcase?cities=${firstElem.name}`);
          setSearchInput("");
          setShowSearchMenu(false);
          break;
        case "industries":
          nav(`/showcase?search=${firstElem.name}&type=industry`);
          setSearchInput("");
          setShowSearchMenu(false);
          break;
        case "size":
          nav(
            `/showcase?sizes=${SearchJson[firstKey]
              ?.find((v) => v.label == firstElem.name)
              ?.value.join(",")}`,
          );
          setSearchInput("");
          setShowSearchMenu(false);
          break;
        default:
          nav(`/showcase?search=${firstElem.name}&type=${firstKey}`);
          setSearchInput("");
          setShowSearchMenu(false);
          break;
      }
    } else {
      if (searchInput.trim()) {
        history(`/project?mask=${searchInput}`);
        setSearchInput("");
      }
    }

    // console.log("Route", route);
    // console.log("First key ", firstKey);
    // console.log("Search Result ", searchResults);
    // console.log("Categories", categories);
    // console.log("Search Keys", searchResultKeys);
    // console.log("First Elem", firstElem);
    // console.log("Search Results Based On First Key", searchBasedOnFirstKey);
    // console.log("Route", [0]);
  };

  // Debounced search/filter logic: search in all categories and group results
  React.useEffect(() => {
    const handler = setTimeout(() => {
      if (searchInput.length > 0 && !ProjectShowcase) {
        // if (searchInput.length > 0) {
        const resultsByCategory = {};

        // Check if the search input is entirely numbers
        const isNumericSearch =
          !isNaN(searchInput) && searchInput.trim() !== "";

        categories.forEach((cat) => {
          let arr = [];
          if (
            cat == "sub_categories" ||
            cat == "color_themes" ||
            cat == "zones" ||
            cat == "size"
          ) {
            arr = SearchJson[cat].map((v) => v.label);
          } else {
            arr = SearchJson[cat];
          }

          let matches = [];

          if (cat === "size" && isNumericSearch) {
            matches = arr.map((item, idx) => {
              console.log({ name: item, id: idx });
              return { name: item, id: idx };
            });
          } else if (TAG_FILTER_PARAMS[cat]) {
            // Match the slug too, so "2600" finds "₹2,600–3,000 / sq ft"
            const query = searchInput.toLowerCase();
            matches = SearchJson[cat]
              .filter(
                (v) =>
                  v.label.toLowerCase().includes(query) ||
                  v.slug.includes(query),
              )
              .map((v, idx) => ({ name: v.label, id: idx }));
          } else {
            matches = arr
              .filter((item) =>
                typeof item === "string"
                  ? item.toLowerCase().includes(searchInput.toLowerCase())
                  : String(item)
                      .toLowerCase()
                      .includes(searchInput.toLowerCase()),
              )
              .map((item, idx) => ({ name: item, id: idx }));
          }

          if (matches.length > 0) {
            resultsByCategory[cat] = matches;
          }
        });
        setSearchResults(resultsByCategory);
      } else {
        setSearchResults({});
      }
    }, 300);
    return () => clearTimeout(handler);
  }, [searchInput]);

  const token = localStorage.getItem("user");
  return (
    <>
      <header className={`${position} top-0 z-10 ${bg} w-full`}>
        <nav className="px-4 lg:px-6 py-2.5">
          <div className="flex flex-wrap justify-between items-center mx-auto container">
            <Link to="/home" className="flex items-center">
              <ImgOptimized
                src={Logo192}
                className="mr-4 w-[130px]"
                alt="AirBrick Logo"
              />
            </Link>
            <div className="flex items-center lg:order-2">
              <button
                onClick={toggleMobileMenu}
                type="button"
                className="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
                aria-controls="mobile-menu-2"
                aria-expanded={isMobileMenuOpen}
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  className={`w-6 h-6 ${isMobileMenuOpen ? "hidden" : ""}`}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
                <svg
                  className={`w-6 h-6 ${isMobileMenuOpen ? "" : "hidden"}`}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>

            <div
              className={`grow w-full lg:w-auto justify-between items-center lg:flex lg:order-1 ${
                isMobileMenuOpen ? "" : "hidden"
              }`}
              id="mobile-menu-2"
            >
              <ul className="flex flex-col mt-4 font-medium lg:flex-row lg:mt-0 text-sm w-full">
                <li className="flex items-center w-full">
                  <form
                    className="w-full md:px-2 lg:px-5"
                    autoComplete="off"
                    onSubmit={searchHandler}
                  >
                    <div className="flex">
                      {/* <div className="relative group">
                      
                        <button
                          id="dropdown-button-2"
                          data-dropdown-toggle="dropdown-search-city"
                          className="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm text-center bg-white border border-gray-300 rounded-l-lg "
                          type="button"
                        >
                          <Unicons.UilLayerGroup
                            size="19"
                            className="hidden md:block"
                          />
                          <span className="ml-1 mr-3">Category</span>
                          <Unicons.UilAngleRightB
                            className="rotate-90"
                            size="18"
                          />
                        </button>
                        <div
                          id="dropdown-search-city"
                          className="absolute top-[85%] z-50 hidden w-full border-t-0 rounded-t-none border border-gray-300 bg-white rounded divide-y divide-gray-100 text-xs group-hover:block"
                          data-popper-reference-hidden
                          data-popper-escaped
                          data-popper-placement="bottom"
                        >
                          <ul
                            className="py-1 text-gray-700 dark:text-gray-200"
                            aria-labelledby="dropdown-button-2"
                          >
                            <li>
                              <Link
                                to="/showcase?tags=open-office"
                                className="inline-flex py-2 px-3 w-full text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                                role="menuitem"
                              >
                                <div className="inline-flex items-center">
                                  Open Office
                                </div>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/showcase?tags=private-office"
                                className="inline-flex py-2 px-3 w-full text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                                role="menuitem"
                              >
                                <div className="inline-flex items-center">
                                  Private Office
                                </div>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/showcase?tags=boardroom"
                                className="inline-flex py-2 px-3 w-full text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                                role="menuitem"
                              >
                                <div className="inline-flex items-center">
                                  Boardroom
                                </div>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/showcase?tags=breakout-space"
                                className="inline-flex py-2 px-3 w-full text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                                role="menuitem"
                              >
                                <div className="inline-flex items-center">
                                  Breakout Space
                                </div>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/showcase?tags=pantry-area"
                                className="inline-flex py-2 px-3 w-full text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                                role="menuitem"
                              >
                                <div className="inline-flex items-center">
                                  Pantry
                                </div>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div> */}
                      <div className=" w-full relative">
                        {isShowProjectDropDown ? (
                          <SearchProjectWithDropDown
                            OnChangeSearchInput={OnChangeSearchInput}
                            allProjects={allProjects}
                          />
                        ) : (
                          <>
                            <input
                              type="text"
                              value={searchInput}
                              onChange={(e) => {
                                if (ProjectShowcase) {
                                  OnChangeSearchInput(e.target.value);
                                  setSearchInput(e.target.value);
                                } else {
                                  setSearchInput(e.target.value);
                                  setShowSearchMenu(e.target.value.length > 0);
                                }
                              }}
                              className="block p-2.5 w-full z-20 text-sm bg-white rounded-lg  border border-gray-300 focus:border-gray-300 focus:ring-0"
                              placeholder={
                                ProjectShowcase
                                  ? "Search projects..."
                                  : "Search Projects, Years, Cities, Countries, Industries, Zones..."
                              }
                              required
                              autoComplete="off"
                            />

                            <button
                              type="submit"
                              className="absolute top-[3px] right-0.5 p-2 text-sm rounded-r-lg bg-white"
                            >
                              <Unicons.UilSearch size="19" />
                            </button>
                          </>
                        )}
                        {/* Search Results Dropdown UI: grouped by category, no tabs */}
                        {showSearchMenu && (
                          <div className="absolute top-full mt-1 w-full left-0 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-64 overflow-auto">
                            {Object.keys(searchResults).length > 0 ? (
                              <div>
                                {categories.map((cat) =>
                                  searchResults[cat] ? (
                                    <div key={cat}>
                                      <div className="px-4 py-2 bg-primary-50 text-primary-700 text-xs font-bold border-b border-gray-100 sticky top-0 capitalize">
                                        {`${cat === "size" ? "Office" : ""} ${cat.split("_").join(" ")} ${cat === "size" ? "(sqft)" : ""}`}
                                      </div>
                                      <ul className="divide-y divide-gray-100">
                                        {searchResults[cat].map(
                                          (result, index) => (
                                            <li
                                              key={result.id}
                                              // style={{
                                              //   backgroundColor:
                                              //     index === 0
                                              //       ? "lightgray"
                                              //       : "",
                                              // }}
                                              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer`}
                                            >
                                              <div
                                                className="flex items-center gap-2"
                                                onClick={() => {
                                                  if (
                                                    cat === "sub_categories" ||
                                                    cat === "color_themes" ||
                                                    cat === "zones" ||
                                                    cat === "size"
                                                  ) {
                                                    if (cat == "color_themes") {
                                                      nav(
                                                        `/showcase?colours=${
                                                          SearchJson[cat]?.find(
                                                            (v) =>
                                                              v.label ==
                                                              result.name,
                                                          )?.slug
                                                        }`,
                                                      );
                                                    } else if (
                                                      cat === "sub_categories"
                                                    ) {
                                                      nav(
                                                        `/showcase?type=${
                                                          SearchJson[cat]?.find(
                                                            (v) =>
                                                              v.label ==
                                                              result.name,
                                                          )?.slug
                                                        }`,
                                                      );
                                                    } else if (cat === "size") {
                                                      nav(
                                                        `/showcase?sizes=${SearchJson[
                                                          cat
                                                        ]
                                                          ?.find(
                                                            (v) =>
                                                              v.label ==
                                                              result.name,
                                                          )
                                                          ?.value?.join(",")}`,
                                                      );
                                                    } else {
                                                      nav(
                                                        `/showcase?tags=${
                                                          SearchJson[cat]?.find(
                                                            (v) =>
                                                              v.label ==
                                                              result.name,
                                                          )?.slug
                                                        }`,
                                                      );
                                                    }
                                                  } else if (
                                                    TAG_FILTER_PARAMS[cat]
                                                  ) {
                                                    nav(
                                                      `/showcase?${TAG_FILTER_PARAMS[cat]}=${
                                                        SearchJson[cat]?.find(
                                                          (v) =>
                                                            v.label ==
                                                            result.name,
                                                        )?.slug
                                                      }`,
                                                    );
                                                  } else if (cat === "years") {
                                                    nav(
                                                      `/showcase?years=${result.name}`,
                                                    );
                                                  } else if (
                                                    cat === "countries"
                                                  ) {
                                                    nav(
                                                      `/showcase?countries=${result.name}&type=country`,
                                                    );
                                                  } else if (cat === "titles") {
                                                    nav(
                                                      `/showcase?search=${result.name}&type=title`,
                                                    );
                                                  } else if (cat === "cities") {
                                                    nav(
                                                      `/showcase?cities=${result.name}`,
                                                    );
                                                  } else if (
                                                    cat === "industries"
                                                  ) {
                                                    nav(
                                                      `/showcase?search=${result.name}&type=industry`,
                                                    );
                                                  } else {
                                                    nav(
                                                      `/showcase?search=${result.name}&type=${cat}`,
                                                    );
                                                  }
                                                  // setSearchResults({})
                                                  setSearchInput(result.name);
                                                  setShowSearchMenu(false);
                                                }}
                                              >
                                                <Unicons.UilSearch
                                                  size="16"
                                                  className="text-primary-500"
                                                />
                                                <span className="font-medium text-gray-800">
                                                  {result.name}
                                                </span>
                                              </div>
                                            </li>
                                          ),
                                        )}
                                      </ul>
                                    </div>
                                  ) : null,
                                )}
                              </div>
                            ) : (
                              <div className="px-4 py-2 text-gray-400">
                                No results found.
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </li>

                <li className="flex items-center">
                  <Link
                    to="/home"
                    className={`block navlinks ${
                      location.pathname === "/home" ? "text-primary-500" : ""
                    } hover hover:text-primary-500 rounded-full flex p-2 gap-1`}
                    aria-current="page"
                  >
                    <Unicons.UilHome size="19" />
                    Home
                  </Link>
                </li>
                <li>
                  <Menu isOpen={exploreMenuOpen}>
                    <MenuButton
                      as={Flex}
                      display={"flex"}
                      className={` navlinks items-center rounded-full flex p-2 gap-1 relative top-[3px]  ${
                        location.pathname === "/showcase" ||
                        location.pathname === "/trending" ||
                        location.pathname === "/collections"
                          ? "text-primary-500"
                          : ""
                      } hover hover:text-primary-500   `}
                      rightIcon={<Icon icon={"mingcute:down-line"} />}
                      _hover={{}}
                      onMouseEnter={() => setExploreMenuOpen(true)}
                      onMouseLeave={() => setExploreMenuOpen(false)}
                    >
                      {/* <Unicons.UilClipboardNotes size="19" /> */}
                      <div className="flex items-center gap-1">
                        <Unicons.UilClipboardNotes size="19" />

                        <span> Explore</span>
                        <Icon icon={"mingcute:down-line"} />
                      </div>
                    </MenuButton>
                    <MenuList
                      onMouseEnter={() => setExploreMenuOpen(true)}
                      onMouseLeave={() => setExploreMenuOpen(false)}
                    >
                      <MenuItem>
                        {" "}
                        <Link
                          to="/showcase"
                          className={`block navlinks ${
                            location.pathname === "/showcase"
                              ? "text-primary-500"
                              : ""
                          } hover hover:text-primary-500 p-2 rounded-full flex gap-1 w-full`}
                        >
                          <Unicons.UilClipboardNotes size="19" />
                          Showcase
                        </Link>
                      </MenuItem>
                      <MenuItem>
                        {" "}
                        <Link
                          to="/trending"
                          className={`block navlinks ${
                            location.pathname === "/trending"
                              ? "text-primary-500"
                              : ""
                          } hover hover:text-primary-500 p-2 rounded-full flex gap-1 w-full`}
                        >
                          <Unicons.UilBookmarkFull size="19" />
                          Trending
                        </Link>
                      </MenuItem>
                      <MenuItem>
                        <Link
                          to="/collections"
                          className={`block navlinks ${
                            location.pathname === "/collections"
                              ? "text-primary-500"
                              : ""
                          } hover hover:text-primary-500 p-2 rounded-full flex gap-1 w-full`}
                        >
                          <Icon
                            icon={"fluent:collections-24-regular"}
                            width={19}
                          />{" "}
                          Collections
                        </Link>
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </li>
                <li>
                  <Menu isOpen={libraryMenuOpen}>
                    <MenuButton
                      as={Flex}
                      display={"flex"}
                      className={` navlinks items-center rounded-full flex p-2 gap-1 relative top-[3px]  ${
                        location.pathname === "/moodboard" ||
                        location.pathname === "/project-showcase" ||
                        location.pathname === "/material" ||
                        location.pathname === "/presentation"
                          ? "text-primary-500"
                          : ""
                      } hover hover:text-primary-500   `}
                      rightIcon={<Icon icon={"mingcute:down-line"} />}
                      onMouseEnter={() => setLibraryMenuOpen(true)}
                      onMouseLeave={() => setLibraryMenuOpen(false)}
                    >
                      {/* <Unicons.UilClipboardNotes size="19" /> */}
                      <div className="flex items-center gap-1 text-nowrap">
                        <Unicons.UilCloudHeart size="19" />

                        <span> Our Library</span>
                        <Icon icon={"mingcute:down-line"} />
                      </div>
                    </MenuButton>
                    <MenuList
                      onMouseEnter={() => setLibraryMenuOpen(true)}
                      onMouseLeave={() => setLibraryMenuOpen(false)}
                    >
                      <MenuItem>
                        {" "}
                        <Link
                          to="/moodboard"
                          className={`block navlinks ${
                            location.pathname === "/moodboard"
                              ? "text-primary-500"
                              : ""
                          } hover hover:text-primary-500 p-2 rounded-full flex gap-1 w-full`}
                        >
                          <Unicons.UilCloudHeart size="19" /> Moodboard
                        </Link>
                      </MenuItem>
                      <MenuItem>
                        {" "}
                        <Link
                          to="/project-showcase"
                          className={`block navlinks ${
                            location.pathname.includes("/project-showcase")
                              ? "text-primary-500"
                              : ""
                          } hover hover:text-primary-500 p-2 rounded-full flex gap-1 w-full`}
                        >
                          <Unicons.UilBuilding size="19" /> Projects
                        </Link>
                      </MenuItem>
                      <MenuItem>
                        <Link
                          to="/material"
                          className={`block navlinks ${
                            location.pathname === "/material"
                              ? "text-primary-500"
                              : ""
                          } hover hover:text-primary-500 p-2 rounded-full flex gap-1 w-full`}
                        >
                          <Icon icon={"lets-icons:materials"} width={19} />{" "}
                          Material
                        </Link>
                      </MenuItem>
                      <MenuItem>
                        <Link
                          to="/presentation"
                          className={`block navlinks ${
                            location.pathname === "/presentation"
                              ? "text-primary-500"
                              : ""
                          } hover hover:text-primary-500 p-2 rounded-full flex gap-1 w-full`}
                        >
                          <Icon icon={"ri:presentation-fill"} width={19} />{" "}
                          Presentation
                        </Link>
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </li>

                {isSuperAdmin && (
                  <li className="flex items-center">
                    <Link
                      to="/user-list"
                      className={`block navlinks ${
                        location.pathname === "/user-list"
                          ? "text-primary-500"
                          : ""
                      } hover hover:text-primary-500 p-2 rounded-full flex gap-1`}
                    >
                      <Unicons.UilUsersAlt size="19" /> Users
                    </Link>
                  </li>
                )}
                {
                  <li className="flex items-center">
                    <Link
                      to="/profile"
                      className={`block navlinks ${
                        location.pathname === "/profile"
                          ? "text-primary-500"
                          : ""
                      } hover hover:text-primary-500 p-2 rounded-full flex gap-1`}
                    >
                      <Unicons.UilUser size="19" /> Profile
                    </Link>
                  </li>
                }

                <li className="flex items-center">
                  <button
                    onClick={() => setIsLogoutOpen(true)}
                    className="text-white bg-primary-500 p-2 rounded-full text-sm md:ml-7"
                  >
                    <span>
                      <Unicons.UilSignout size="19" />
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
      {isLogoutOpen && (
        <PopupWrapper
          onClose={() => setIsLogoutOpen(false)}
          heading="Log Out"
          width="max-w-[400px]"
        >
          <div className="">
            <p className="text-gray-600 text-sm">
              Are you sure you want to log out?
            </p>
            <div className="mt-4 flex justify-end gap-3">
              <Button
                onClick={() => setIsLogoutOpen(false)}
                variant="outline"
                size="sm"
                colorScheme="gray"
              >
                Cancel
              </Button>
              <Button onClick={logoutuser} colorScheme="red" size="sm">
                Logout
              </Button>
            </div>
          </div>
        </PopupWrapper>
      )}
    </>
  );
}

export default Header;
